import { motion, MotionConfig } from "framer-motion";
import { BarChart3, TrendingUp, Award } from "lucide-react";
import { Card } from "../../../components/ui/card";
import { useInViewOnce } from "../../../hooks/useInViewOnce";

const SPRING: [number, number, number, number] = [0.34, 1.56, 0.64, 1];

const PILLARS = [
  {
    icon: BarChart3,
    title: "Transparência total",
    desc: "Mesma verdade para sala, casa e coordenação — menos ruído, mais alinhamento.",
  },
  {
    icon: TrendingUp,
    title: "Decisão com dados",
    desc: "Indicadores por turma, disciplina e professor. Priorize onde o impacto é maior.",
  },
  {
    icon: Award,
    title: "Aprendizado adaptativo de verdade",
    desc: "Do questionário ao dia a dia: interface, ritmo e revisão respondem ao perfil e ao comportamento na plataforma.",
  },
];

const cardVariants = {
  hidden: { opacity: 0, y: 28 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: SPRING, delay: i * 0.1 },
  }),
};

export function TrustSection() {
  const { ref, isVisible } = useInViewOnce();

  return (
    <MotionConfig reducedMotion="user">
      <section
        ref={ref}
        className="border-b border-white/[0.06] py-16 sm:py-20"
      >
        <div className="container mx-auto max-w-7xl px-4 sm:px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, ease: [0, 0, 0.2, 1] }}
            className="mb-10 text-center sm:mb-14"
          >
            <h2 className="font-display text-xl font-bold tracking-tight text-white sm:text-2xl md:text-3xl">
              Controle real, não promessa de{" "}
              <span className="bg-gradient-to-r from-teal-300 to-cyan-300 bg-clip-text text-transparent">
                IA mágica
              </span>
            </h2>
          </motion.div>

          <div className="mx-auto grid max-w-5xl gap-4 sm:gap-6 md:grid-cols-3">
            {PILLARS.map((d, i) => (
              <motion.div
                key={d.title}
                custom={i}
                variants={cardVariants}
                initial="hidden"
                animate={isVisible ? "visible" : "hidden"}
              >
                <Card className="card-lift h-full border-white/10 bg-white/[0.03] p-5 text-center backdrop-blur-md sm:p-6 md:text-left">
                  <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-white/5 md:mx-0">
                    <d.icon className="h-6 w-6 text-cyan-300" aria-hidden />
                  </div>
                  <h3 className="font-display text-lg font-semibold text-white">
                    {d.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-400">{d.desc}</p>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </MotionConfig>
  );
}
